import getApi from '../../../api/apisauceConfig'
import { ApiDetailedActe, deserializeDetailedActeResponse } from './mapper/actes.mapper'

export const getActe = (codeActe: string) =>
  getApi().get<ApiDetailedActe>(`/ccam/actes/${codeActe}`).then(deserializeDetailedActeResponse)
